import { Link } from "react-router-dom";
import { useMarket } from "./MarketProvider";
import { useV3 } from "./useV3";
import { fill } from "./strings";
import { Flag } from "./Icons";

/* «قريبًا» — this market exists but is not open.
 *
 * WHY A BAND AND NOT A BLANK PAGE. /sa/ is a real URL for a real market that
 * has no listings yet. Before the market switcher shipped, /sa/ silently
 * served EGYPT's property; now it correctly shows Saudi Arabia's own
 * emptiness — but an empty page and a page for a market we have not opened
 * look identical, and only one of them is a bug. This says which.
 *
 * It renders in the shell, so it is on every page of a closed market rather
 * than on a home page somebody may never see, and it carries the way out: a
 * link to a market that IS open.
 *
 * NOT DISMISSIBLE, unlike the suggestion band beside it. The suggestion is an
 * offer and can be declined; this is the reason the page below it is empty,
 * and hiding it would leave the emptiness unexplained.
 */
export function MarketComingSoon() {
  const { comingSoon, market, markets } = useMarket();
  const { s, ar } = useV3();

  if (!comingSoon || !market) return null;

  const name = ar ? market.nameAr : market.nameEn;
  const open = markets.find((m) => m.active);

  return (
    <div data-component="market-coming-soon" className="sq-market-coming-soon" role="status">
      <Flag code={market.code} />
      <span>
        <strong>{fill(s.marketComingSoon.title, { market: name })}</strong>{" "}
        {s.marketComingSoon.body}{" "}
        {open && (
          <Link to={`/${open.slug}/`} className="sq-link--underline">
            {fill(s.marketComingSoon.go, { market: ar ? open.nameAr : open.nameEn })}
          </Link>
        )}
      </span>
    </div>
  );
}
